import { render } from "./GalleryPurchase.vue?vue&type=template&id=431af3ae&scoped=true"
import script from "./GalleryPurchase.vue?vue&type=script&lang=js"
export * from "./GalleryPurchase.vue?vue&type=script&lang=js"

import "./GalleryPurchase.vue?vue&type=style&index=0&id=431af3ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431af3ae"]])

export default __exports__